export const INPROGRESS = 'IN PROGRESS'
export const INREVIEW = 'IN REVIEW'
export const COMPLETED = 'COMPLETED'
